'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'fire-flame';
var width = 384;
var height = 512;
var aliases = ["flame"];
var unicode = 'f6df';
var svgPathData = 'M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4 125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9C35.2 284.8 32 303.1 32 321.6 32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l0 0-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1 0 105.2-86.8 190.4-192 190.4S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM187.4 206l0 .6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4 0 30.5-24.7 55.3-55.3 55.3l-2.5 0c-31.9 0-57.7-25.8-57.7-57.7l0-22.2c-11 12.2-17.1 28.1-17.1 44.7l0 3.2c0 53 43 96 96 96l7.3 0c49 0 88.7-39.7 88.7-88.7 0-27.9-12.2-54.3-33.4-72.4l-44.6-38.1c-9.7-8.3-16.4-19.6-19-31.9-2.4 6.8-3.6 13.9-3.6 21.1zm9.9-78c13.5 0 24.4 10.9 24.4 24.4l0 20.2c0 7.6 3.3 14.9 9.1 19.8l44.6 38.1c28.3 24.2 44.6 59.5 44.6 96.7 0 66.7-54.1 120.7-120.7 120.7l-7.3 0c-70.7 0-128-57.3-128-128l0-3.2c0-27.9 11.8-54.6 32.6-73.3l5.3-4.8c4.8-4.3 10.9-6.7 17.4-6.7 14.3 0 25.9 11.6 25.9 25.9l0 36.4c0 14.2 11.5 25.7 25.7 25.7l2.5 0c12.8 0 23.3-10.4 23.3-23.3 0-6-2.3-11.8-6.5-16.1l-8.2-8.5c-17-17.6-26.4-41.1-26.4-65.5l0-.6c0-13.9 3-27.6 8.9-40.2l10.9-23.6c4-8.6 12.6-14.1 22.1-14.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFireFlame = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;